// extracted by mini-css-extract-plugin
export default {"shareContainer":"Share_shareContainer__kFZoI","shareLinkWrapper":"Share_shareLinkWrapper__eujJX"};